import Loadable from 'UIComponents/decorators/Loadable';
const AsyncDeleteViewModal = Loadable({
  loader: () => import( /* webpackChunkName: "delete-view-modal" */'find-and-filter-components/custom-views-build/public/DeleteCustomViewModal'),
  // don't render a loading spinner for this because it's a UIModalPanel
  LoadingComponent: () => null
});
export default AsyncDeleteViewModal;